module.exports = __webpack_public_path__ + "img/vocabulary-5-en.0affbf2e.png";